<template>
  <div class="add-form">
    <Form ref="addForm" :model="form" :rules="diyData.rules" :label-width="100">
      <div class="tag-title">通知</div>
      <FormItem label="是否显示">
        <RadioGroup v-model="form.status">
          <Radio label="1">显示</Radio>
          <Radio label="2">隐藏</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="文章分类" prop="category_id">
        <Select filterable placeholder="请选择文章分类" style="width: 200px" v-model="form.category_id">
          <Option v-for="item in apiData.categoryList" :value="item.id" :label="item.title" :key="item.id"></Option>
        </Select>
      </FormItem>
    </Form>
    <Button type="primary" style="width: 90px; margin-right: 20px" @click="submit">保存</Button>
  </div>
</template>

<script>
  import * as apiSetting from '@/api/setting'
  import * as apiArticle from '@/api/article'
  export default {
    name: 'add-form',
    data() {
      return {
        query: {},
        search: {},
        diyDom: {},
        // 表单数据
        form: {
          status:'1',
          category_id: '',
        },
        diyData: {
          rules: {
            category_id: [
              {
                required: true,
                message: '文章分类不能为空',
                trigger: 'change',
              },
            ],
          },
        },
        apiData: {
          categoryList: [],
        },
      }
    },
    computed: {},
    methods: {
      // 获取文章分类
      getCategory() {
        apiArticle.apiArticleCategoryListNoPage().then(res => {
          this.apiData.categoryList = res.data.map(item => {
            return {
              ...item,
              id: item.id + '',
            }
          })
        })
      },
      // 获取详情
      getDetail() {
        this.$store.commit('setSpinShow', true)
        apiSetting
          .apiGetSystem('notice')
          .then(res => {
            this.form.category_id = res.data.category_id || ''
            this.form.status = res.data.status + ''
          })
          .finally(() => this.$store.commit('setSpinShow', false))
      },
      submit() {
        this.$refs['addForm'].validate(valid => {
          if (valid) {
            apiSetting
              .apiSetSystem('notice', {
                notice: this.form,
              })
              .then(res => {
                this.$Message.success('保存成功')
                this.$bus.$emit('on-change')
                this.getDetail()
              })
          }
        })
      },
    },
    mounted() {
      this.getCategory()
      this.getDetail()
    },
  }
</script>

<style scoped lang="less">
  .add-form {
    border: 1px solid #ededed;
    margin: 0 20px;
    padding: 26px 20px;

    .title {
      border-left: 5px solid #2d8cf0;
      padding: 0 0 0 10px;
      margin: 0 20px 20px;
      font-weight: bold;
    }
  }
</style>
